import axios from "axios";
import { base_url } from "./ApiConst";
import { Token } from "./Token";
import { STORAGE_CONSTANTS } from "../shared/Constants/Constants";
// import { toast } from "react-toastify";

export const axiosInstance = axios.create({
  baseURL: base_url,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    // Check if the specific request config has useUserToken set to true
    const useUserToken = config.useUserToken;
    const isLoggedIn =
      localStorage.getItem(STORAGE_CONSTANTS.IS_LOGGED_IN) === "true";

    // If the request requires the user token AND the user is logged in
    if (useUserToken && isLoggedIn) {
      const userToken = localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN);
      config.headers["Authorization"] = `Token ${userToken}`;
    } else {
      // Otherwise, default to the guest token everywhere else
      config.headers["Authorization"] = Token;
    }

    return config;
  },
  (error) => Promise.reject(error)
);


// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     // Show toast error message
//     if (error.response && error.response.data && error.response.data.detail) {
//       toast.error(error.response.data.detail);
//     } else if (error.message) {
//       toast.error(error.message);
//     } else {
//       toast.error("An unexpected error occurred.");
//     }
//     return Promise.reject(error);
//   }
// );
